module.exports = __webpack_public_path__ + "static/img/lgchem.06ac94b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/lgchem.jpg
// module id = yJPw
// module chunks = 0